import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconCaretUp: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M2.85479 11.468C2.89782 11.5703 2.9702 11.6577 3.06279 11.719C3.15538 11.7803 3.26405 11.8128 3.3751 11.8125L14.6251 11.8125C14.7362 11.8128 14.8448 11.7803 14.9374 11.719C15.03 11.6577 15.1024 11.5703 15.1454 11.468C15.1859 11.3641 15.1962 11.2508 15.1751 11.1413C15.1539 11.0318 15.1022 10.9305 15.0259 10.8492L9.40088 5.22422C9.29337 5.12025 9.14966 5.06214 9.0001 5.06214C8.85054 5.06214 8.70684 5.12025 8.59932 5.22422L2.97432 10.8492C2.89801 10.9305 2.84629 11.0318 2.82514 11.1413C2.80398 11.2508 2.81427 11.3641 2.85479 11.468Z"
        fill={rest?.$color}
      />
    </svg>
  </IconStyled>
);

IconCaretUp.defaultProps = iconDefaultProps;
IconCaretUp.displayName = 'IconCaretUp';

export default IconCaretUp;
